import {Utils} from '@busuu/legacy-core';
import PubSub from 'pubsub-js/src/pubsub.js';
import AuthenticationService from 'authentication/authentication-service.js';
import RegistrationService from 'registration/registration-service.js';
import RegistrationTracking from 'tracking/pages/tracking-register.js';
import CaptchaService from 'captcha/captcha-service.js';
import ReferralService from 'referral/referral-service.js';
import FormUtils from 'helpers/form-utils.js';
import ConfigService from 'config/config-service.js';
import {validateTermsAcceptance} from 'registration/registration-busuu.js';

/**
 * Private vars
 */
let errorElement;
let FBButton;
let optInToggleElem;
let optInPromotions;
let FBButtonInner = null;
const disabledClass = 'social-auth--disabled';

/**
 * Enable/Disable button state
 */
const enableButton = () => {
    Utils.removeClass(FBButton, disabledClass);
};

const disableButton = () => {
    Utils.addClass(FBButton, disabledClass);
};

/**
 * Enable/Disable button state with loading
 */
const enableButtonAndDisableLoading = () => {
    enableButton();
    Utils.removeClass(FBButtonInner, 'main-spinner-a');
};

const disableButtonAndEnableLoading = () => {
    disableButton();
    Utils.addClass(FBButtonInner, 'main-spinner-a');
};

/**
 * Error Tracking sent after Facebook API
 * fail or Busuu API fail
 */
const sendTrackingError = (type) => {
    RegistrationTracking.sendRegistrationErrorTracking('FACEBOOK', {
        error: type,
    });
};

const handleError = ({type = 'UNKNOWN_TYPE'}) => {
    sendTrackingError(type);
    enableButtonAndDisableLoading();
};

const redirect = (url) => {
    window.location.href = url;
};

const onRegistrationSuccess = ({user, registrationResponse}) => {
    const redirectURL = RegistrationService.getAfterRegistrationURL({
        defaultURL: FBButton.getAttribute('data-redirect'),
        registrationResponse,
        user,
    });

    if (registrationResponse.backendRedirection) {
        return redirect(redirectURL);
    }

    return RegistrationTracking.sendRegistrationSuccessTracking('FACEBOOK', {
        email_opt_in: optInPromotions,
    }).then(redirect.bind(null, redirectURL));
};

const createUser = (facebookToken, captchaToken) => {
    const getParams = (countryCode) => {
        const getElementValue = (el) => {
            return el.value === 'en' ? 'enc' : el.value;
        };
        const referralCode = ReferralService.getReferralUserCode();
        const perkToken = ReferralService.getPerkToken();
        const timezone = RegistrationService.getTimezoneOffset();
        const defaultInterfaceLang = Utils.getById('register-interface-lang');
        const interfaceLang = RegistrationService.getInterfaceLanguage(defaultInterfaceLang, countryCode);
        const learningLang = getElementValue(Utils.getById('register-learning-lang'));
        optInPromotions = RegistrationService.canOptInPromotions(countryCode, optInToggleElem);

        return {
            token: facebookToken,
            learning_language: learningLang,
            interface_language: interfaceLang,
            speaking_language: interfaceLang,
            opt_in_promotions: optInPromotions,
            ...(referralCode && {
                referral_token: referralCode,
            }),
            ...(perkToken && {
                perk_token: perkToken,
            }),
            ...(timezone && {timezone}),
            ...(captchaToken && {
                captcha_token: captchaToken,
            }),
        };
    };

    return ConfigService.getCountryCode()
        .catch(() => {
            return null;
        })
        .then(getParams)
        .then(RegistrationService.createFacebookUser)
        .then(onRegistrationSuccess);
};

const initCaptcha = (facebookToken) => {
    const onSuccess = (result) => {
        return createUser(facebookToken, result.token);
    };
    return CaptchaService.initializeAndRenderChallenge({
        endpointType: 'register_vendor',
        containerID: 'register-recaptcha',
    }).then(onSuccess);
};

const checkLoginState = (e) => {
    e.preventDefault();

    if (!validateTermsAcceptance()) {
        return;
    }

    disableButtonAndEnableLoading();
    FormUtils.hideElement(errorElement);

    AuthenticationService.authUserOnFacebook().then(initCaptcha).catch(handleError);
};

const init = () => {
    FBButton = Utils.getById('facebook-registration');
    if (FBButton) {
        optInToggleElem = Utils.getById('register-communications-opt-in-toggle');
        FBButtonInner = Utils.getElementByClass('js-facebook-inner', FBButton);
        errorElement = Utils.getById('error-generic');
        FBButton.addEventListener('click', checkLoginState);
        disableButton();
        PubSub.subscribe('FACEBOOK_API_LOADED', enableButton);
    }
};

init();
